import { render, staticRenderFns } from "./setting-emailBranding.vue?vue&type=template&id=40466175&scoped=true&"
import script from "./setting-emailBranding.vue?vue&type=script&lang=js&"
export * from "./setting-emailBranding.vue?vue&type=script&lang=js&"
import style0 from "./setting-emailBranding.vue?vue&type=style&index=0&id=40466175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40466175",
  null
  
)

export default component.exports